module.exports = __webpack_public_path__ + "img/vko4.6c2cd666.jpg";